import { AppConstants } from 'src/app/shared/constants/constants';
import { Component, Input, OnInit } from '@angular/core';
import { LanguageService } from '../../service/language.service';
import { TranslationService } from '../../service/translation.service';
import { StoreManagerService } from '../../store-manager/services/store-manager.service';
import { CrowdinOtaService } from '../../service/crowdin-ota/crowdin-ota.service';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { LoadingSpinnerService } from '../../service/loading-spinner.service';

@Component({
  selector: 'app-language-selection',
  templateUrl: './language-selection.component.html',
  styleUrls: ['./language-selection.component.scss']
})
export class LanguageSelectionComponent implements OnInit {

  @Input() showLanguageSelectionModal: boolean = false;
  translationData: any;
  allLanguages: any[] = [];
  BUTTON_NAMES = AppConstants.COMMON_BUTTON_LABELS;

  constructor(private readonly _languageService: LanguageService, 
    private _crowdinOtaService: CrowdinOtaService,
    private location: Location,
    private _router: Router,
    private _loadingSpinnerService: LoadingSpinnerService,
    private readonly _translationService: TranslationService,
    private readonly _storeManagerService: StoreManagerService) {
    this._storeManagerService.getUserSelectedLanguageFromStore();
   }

  ngOnInit(): void {
    this.allLanguages = this._translationService.supportedLanguagesForDisplay;
  }

  public closeLangSelection(): void {
    this._languageService.showLanguageSelectionModal.next(false);
  }

  public async switchLanguage(language: string): Promise<void> {
    const pattern = /\/[a-z]{2}-[A-Z]{2}(?=\/|$)/;
    const currentUrl = this._router.url;
    let updatedUrl = currentUrl;
    this._loadingSpinnerService.show();
    if (pattern.test(currentUrl)) {
      updatedUrl = currentUrl.replace(pattern, `/${language}`);
    } else {
      // If no language pattern found, prepend the language to the URL
      updatedUrl = `/${language}${currentUrl}`;
    }
    
    this.location.replaceState(updatedUrl);
    const languageCode = language.split('-')[0];
    
    try {
      await this._crowdinOtaService.useLanguage(languageCode);
      console.log(`Switched to ${languageCode}`);
      setTimeout(() => {
        this._storeManagerService.setUserLanguageToStore(language);
        this._loadingSpinnerService.hide();
        this.closeLangSelection();
      }, 10);
    } catch (error) {
      console.error('Error switching language:', error);
    }
  
  }

  ngOnDestroy(): void {
    this._languageService.showLanguageSelectionModal.next(false);
  }

}